export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Red-1.f8dfd6e5.jpg";